module.exports = __webpack_public_path__ + "img/52.4.NH3-N.4326fe6c.png";